module.exports = __webpack_public_path__ + "img/curved14.34ecccd6.jpg";